import type { ISelectOption } from 'stories/components/SelectOptionInputs/types'

import type { ILoanOriginSection, ISelectRangeOption, ISelectValueOption, IVisibleProp } from './loan.input.visibility.type'

export type ContractorInputType = Omit<IVisibleProp, 'options'> & {
  options?: ISelectOption[] | ISelectRangeOption[] | ISelectValueOption[] | Record<string, string>
  prefix?: string
}

/** Same shape as loan sections; stored per origin (not a root-level bag). */
export type IContractorOriginSection = ILoanOriginSection

export interface IContractorPropsPerOrigin {
  title?: string
  inputs: Record<string, ContractorInputType>
  sections?: IContractorOriginSection[]
}

export enum ContractorOrigin {
  Welcome = 'welcome',
  GeneralInformation = 'general',
  CapabilityStatement = 'capability',
  SubcontractorReferences = 'subcontractor',
  SupplierReferences = 'supplier',
  ClientReferences = 'client',
  ConstructionTrackRecords = 'track',
  ConsentForm = 'consent',
  AcknowledgementSign = 'sign',
  Documents = 'documents',
}

export const contractorOriginOptions: Record<ContractorOrigin, string> = {
  [ContractorOrigin.Welcome]: 'To Whom It May Concern',
  [ContractorOrigin.GeneralInformation]: 'Contractor General Information',
  [ContractorOrigin.CapabilityStatement]: 'Statement of Capabilities',
  [ContractorOrigin.SubcontractorReferences]: 'Subcontractor References',
  [ContractorOrigin.SupplierReferences]: 'Supplier References',
  [ContractorOrigin.ClientReferences]: 'Client References',
  [ContractorOrigin.ConstructionTrackRecords]: 'Construction Track Records',
  [ContractorOrigin.ConsentForm]: 'Contractor Consent Form',
  [ContractorOrigin.AcknowledgementSign]: 'Acknowledgement & Sign',
  [ContractorOrigin.Documents]: 'Contractor Documents',
}

/** Origins that support Loan-style section grouping in admin + application UI. */
export const contractorOriginsWithSections: ContractorOrigin[] = [
  ContractorOrigin.GeneralInformation,
  ContractorOrigin.CapabilityStatement,
]

export const canContractorOriginHaveSection = (origin: ContractorOrigin) =>
  contractorOriginsWithSections.includes(origin)

export type ContractorFieldProps = {
  [origin in ContractorOrigin]: IContractorPropsPerOrigin
}

export const isContractorOriginHasStatus = (origin: ContractorOrigin) => {
  return ![ContractorOrigin.Welcome, ContractorOrigin.Documents].includes(origin)
}
